export interface FormSubmission extends ApiEntity {
  formId: id
  submitted: boolean
  userId?: id
  form?: Form
  // Stageplein specific fields
  openAt?: Date
  dueAt?: Date
}

export interface FormQuestionResponse extends ApiEntity {
  formSubmissionId: id
  formQuestionId: id
  value: id
}

export function useFetchFormSubmissionByToken(token: string) {
  return useJsonApiFetch<FormSubmission &
    { form: Form & { formQuestions: FormQuestion[] }
      formQuestions: FormQuestion[]
      formQuestionResponses: FormQuestionResponse[]
    }>(
    `/api/v1/form_submissions/t/${token}?include=form,form_questions,form_question_responses`,
    )
}

export async function submitFormSubmission(token: string, payload: Record<string, any>) {
  return await $api(`/api/v1/form_submissions/t/${token}/submit`, {
    method: 'POST',
    body: {
      data: {
        type: 'form_submission',
        id: token,
        attributes: payload,
      },
    },
  })
}

export async function submitPublicForm(formId: id, payload: Record<string, any>) {
  return await $api(`/api/v1/form_submissions/${formId}/submit_public`, {
    method: 'POST',
    body: {
      data: {
        type: 'form_submission',
        attributes: payload,
      },
    },
  })
}

interface FormSubmissionWithRelations extends FormSubmission {
  form: Form
  formQuestions: FormQuestion[]
  formQuestionResponses: FormQuestionResponse[]
}

// Fetch all form submissions for the given form id
export function useFetchFormSubmissions(formId: id) {
  return useJsonApiFetch<(FormSubmissionWithRelations)[]>(`/api/v1/form_submissions?filter[form_id_eq]=${formId}&include=form,form_questions,form_question_responses`)
}

// Fetch a single form submission by id
export function useFetchFormSubmissionById(submissionId: id) {
  return useJsonApiFetch<FormSubmissionWithRelations>(`/api/v1/form_submissions/${submissionId}?include=form,form_questions,form_question_responses`)
}
